module.exports = "/_next/static/images/operator-logos-da8ce08904da4f273220dce8209ad42d.svg";